import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class TenantManager extends React.Component {
    render() {
        const { role } = this.props;

        if (this.props[role.type]) {
            let Element = this.props[role.type];

            return <Element {...this.props} />;
        }

        return null;
    }
}

TenantManager.defaultProps = {
    role: undefined
};
TenantManager.propTypes = {
    role: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    role: state.identity.role
});

export default connect(mapStateToProps, null)(TenantManager);



// WEBPACK FOOTER //
// ./src/components/tenantManager/index.jsx